module.exports = __webpack_public_path__ + "static/media/format_list.0704518c.svg";